/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChainTransactionsRequest
 */
export interface ChainTransactionsRequest {
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionsRequest
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionsRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ChainTransactionsRequest
     */
    method?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChainTransactionsRequest
     */
    runtime: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionsRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionsRequest
     */
    size: number;
}

export function ChainTransactionsRequestFromJSON(json: any): ChainTransactionsRequest {
    return ChainTransactionsRequestFromJSONTyped(json, false);
}

export function ChainTransactionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainTransactionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'height': !exists(json, 'height') ? undefined : json['height'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'method': !exists(json, 'method') ? undefined : json['method'],
        'runtime': json['runtime'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function ChainTransactionsRequestToJSON(value?: ChainTransactionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'height': value.height,
        'address': value.address,
        'method': value.method,
        'runtime': value.runtime,
        'page': value.page,
        'size': value.size,
    };
}


